import type { InfringementStatus } from 'src/context/api/brandInfringement/api';

export interface StatusVisual {
    label: string;
    bg: string;
    color: string;
    icon: string; // iconify name
    action: 'download' | 'play' | 'play-disabled' | 'loading';
    tooltip?: string;
}

export const STATUS_CONFIG: Record<InfringementStatus, StatusVisual> = {
    report_ready: {
        label: 'Report ready',
        bg: 'rgba(34,197,94,0.16)',
        color: '#118d57',
        icon: 'eva:checkmark-circle-2-outline',
        action: 'download',
    },
    not_eligible: {
        label: 'Not eligible',
        bg: '#fbf3da',
        color: '#a87710',
        icon: 'eva:alert-triangle-outline',
        action: 'play-disabled',
        tooltip: 'Number of impressions is too low to launch a Brand Infringment.',
    },
    no_longer_active: {
        label: 'No longer active',
        bg: 'rgba(145,158,171,0.12)',
        color: '#637381',
        icon: 'eva:alert-circle-outline',
        action: 'play-disabled',
    },
    capturing_data: {
        label: 'Capturing data',
        bg: 'rgba(217,228,242,0.36)',
        color: '#1e88e5',
        icon: 'eva:file-text-outline',
        action: 'loading',
    },
    start_capture: {
        label: 'Start capture',
        bg: 'rgba(217,228,242,0.36)',
        color: '#1e88e5',
        icon: 'eva:file-text-outline',
        action: 'play',
    },
};
